import { useLazyQuery } from '@apollo/client';
import { GRAPHQL_LISTAR_RELATORIO_PLAYER_TEMPO_ONLINE } from 'gql/relatorio';
import { useCreateCsv } from 'hooks/useCreateCsv';
import { useCallback, useContext, useRef } from 'react';
import { AuthContext } from 'routes/auth.context';
export const useEntregadorRelatorioTempoOnline = () => {
    const { alertConfirm } = useContext(AuthContext);
    const { handleGenerateCsv } = useCreateCsv();
    const currentDate = useRef({ dataInicio: '', dataFim: '' });

    const [handleQuery, { loading }] = useLazyQuery(
        GRAPHQL_LISTAR_RELATORIO_PLAYER_TEMPO_ONLINE,
        {
            onCompleted: (response) => {
                const content: any = [
                    [
                        'Nome entregador',
                        'Periodo',
                        'Data da Disponibilidade',
                        'Tempo Online',
                        'Porcentagem Tempo Online',
                    ],
                ];

                response.relatorioPlayerTempoOnline.forEach((props) => {
                    content.push([
                        props.nomeCompleto,
                        props.nomePeriodo,
                        props.escalaData,
                        props.tempoOnline,   
                        props.porcentagemOnline                 
                    ]);
                });

                handleGenerateCsv({
                    fileName: `RELATÓRIO TEMPO ONLINE ${currentDate.current.dataInicio} à ${currentDate.current.dataFim}`,
                    content,
                });
            },
            onError: ({ message }) => {
                alertConfirm({
                    tipo: 'erro',
                    titulo: 'Erro',
                    conteudo: message,
                });
            },
        }
    );
    const handleClick = useCallback(
        (variables) => {
            currentDate.current = variables;
            handleQuery({ variables });
        },
        [handleQuery]
    );
    return { handleClick, loading };
};
